import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { PdfTemplate } from './pdfHtmlTemplate';
import { PdfData } from '@/models';

export const GenerateRowSets = ({ mediaPlan, ...data }: PdfData): HTMLTableRowElement[][] => {
  const channels = data?.channels ?? [];
  const tableDoc = (
    <PdfTemplate {...{ mediaPlan, ...data }}>
      {channels.map((el, index) => (
        <tr key={`${el.channel}${index}`}>
          <td>{el.channel ?? 'N/A'}</td>
          <td>{el.product ?? 'N/A'}</td>
          <td>{el.country ?? 'N/A'}</td>
          <td>{el.currency ?? 'N/A'}</td>
          <td>{el.dsp ?? 'N/A'}</td>
          <td>{el.targetingDetails ?? 'N/A'}</td>
          <td>{el.kpi ?? 'N/A'}</td>
          <td>{Array.isArray(el.formats) ? el.formats.join(', ') : (el.formats ?? 'N/A')}</td>
          <td>{el.buyingMetric ?? 'N/A'}</td>
          <td>{el.startDate ?? 'N/A'}</td>
          <td>{el.endDate ?? 'N/A'}</td>
          <td>{el.sellRate ?? 'N/A'}</td>
          <td>{el.budget ? `£${el.budget}` : 'N/A'}</td>
          <td>{el.impressions ?? 'N/A'}</td>
          {data.ctr && el.clicks && <td>{el.clicks ?? 'cN/A'}</td>}
          {data.vtr && el.views && <td>{el.views ?? 'vN/A'}</td>}
          {data.ltr && el.listens && <td>{el.listens ?? 'lN/A'}</td>}
        </tr>
      ))}
    </PdfTemplate>
  );

  const iframe = document.createElement('iframe');

  document.body.appendChild(iframe);
  const iframeDoc = iframe?.contentDocument || iframe.contentWindow?.document;
  iframeDoc!.body.innerHTML = ReactDOMServer.renderToString(tableDoc);
  const body = iframeDoc?.querySelector('body');
  const table = body?.querySelector('.table-container table');

  if (!body || !table) return [];

  const trs = [...table!.querySelectorAll('tr')];
  const header = trs.splice(0, 1);
  const pages: HTMLTableRowElement[][] = [];

  const maxTableHeight = 450 - header[0].clientHeight;
  while (trs.filter((el) => el).length) {
    const page: HTMLTableRowElement[] = [];
    let offset = 0;
    const rows = [...trs];
    for (let i = 0; i < rows.length; i++) {
      const element = rows[i];
      if (element && offset + element.clientHeight < maxTableHeight) {
        offset += element.clientHeight;
        delete trs[i];
        page.push(element);
      }
    }

    if (page.length >= 1) {
      pages.push(page);
    }
  }

  const lastPage = pages[pages.length - 1];
  const lastPageHeight = lastPage?.reduce((acc, page) => acc + page.clientHeight, 0) ?? 0;

  if (lastPageHeight > 250) {
    pages.push([]);
  }
  iframe.remove();
  return pages;
};

export const RenderPage = ({ mediaPlan, rows, ...data }: PdfData & { rows: HTMLTableRowElement[] }) => (
  <PdfTemplate key={mediaPlan.campaign.name} {...{ mediaPlan, ...data }}>
    {rows.map((row, index) => (
      <div key={index} dangerouslySetInnerHTML={{ __html: row.outerHTML }} />
    ))}
  </PdfTemplate>
);
